import { render, staticRenderFns } from "./ComplexWriteBody.vue?vue&type=template&id=3153a431&scoped=true"
import script from "./ComplexWriteBody.vue?vue&type=script&lang=js"
export * from "./ComplexWriteBody.vue?vue&type=script&lang=js"
import style0 from "./ComplexWriteBody.vue?vue&type=style&index=0&id=3153a431&prod&scoped=true&lang=scss"
import style1 from "./ComplexWriteBody.vue?vue&type=style&index=1&id=3153a431&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3153a431",
  null
  
)

export default component.exports